import React from 'react';
import './FloatingButtons.css';

function FloatingButtons() {
  return (
    <div className="floating-container">
      {/* Sol Alt: Arama Butonu */}
      <a href="tel:+905058865977" className="float-btn phone-float" title="Hemen Ara">
        <i className="fas fa-phone"></i>
      </a>

      {/* Sağ Alt: WhatsApp Butonu */}
      <a 
        href="https://wa.me/905058865977" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="float-btn whatsapp-float"
        title="WhatsApp ile İletişime Geç"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
}

export default FloatingButtons;